import { Table } from 'antd'
import styled from 'styled-components'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`
const StyledTable = styled(Table)`
  background: var(--background);
  overflow: auto;
  border-radius: 9px;
  margin: 20px;
  height: 100%;
  .ant-pagination {
    padding: 0px 10px;
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: var(--background);
    border: 1px solid var(--borderColor);
  }
  .ant-table-thead > tr > th {
    background: var(--background);
    font-weight: 600;
    color: var(--primaryColor);
  }
  tr.ant-table-expanded-row > td {
    background: var(--background);
  }
  .ant-progress-text {
    color: var(--primaryColor);
  }
`
const StyledFooter = styled.div`
  padding: 12px 12px;
  text-align: right;
  background: var(--background);
  width: 100%;
  border-top: 1px solid var(--borderColor);
`

export {
  PageContainer,
  StyledTable,
  StyledFooter
}
